import React, { useId } from 'react'
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getDayName } from '../../utils/DateFormat';
import "./styles.css"

const DateInput: React.FC<DatePickerProps<any> & { label?: string }> = ({ label, ...props }) => {

    const id = useId();
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ptBR' localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
            <label htmlFor={id} aria-label={label || ""} />
            <DatePicker
                format='DD/MM/YYYY'
                dayOfWeekFormatter={(day: string) => `${getDayName(day)}`}
                {...props}
                className='date-input'
                slotProps={{
                    textField: { id },
                    day: {
                        sx: {
                            '&:focus': {
                                outline: '2px solid #1976d2',
                                outlineOffset: '2px',
                                borderRadius: '50%',
                            },
                            '&.Mui-selected:focus': {
                                outline: '2px solid #004ba0',
                            },
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
};

export default DateInput;
